import React, { useEffect } from 'react';

const zendeskTheme = window.post_template.checkout_v3_footer;
const setting = {
	color: {
		launcher: zendeskTheme.checkout_v3_zendeskBackground,
		launcherText: zendeskTheme.checkout_v3_zendeskTextColor,
		button: zendeskTheme.checkout_v3_zendeskLauncherTheme,
		resultLists: zendeskTheme.checkout_v3_zendeskLauncherTheme,
		header: zendeskTheme.checkout_v3_zendeskLauncherTheme,
	},
	launcher: {
		chatLabel: {
			'en-US': 'Need Help',
		},
	},
	contactForm: {
		fields: [
			{
				id: 'description',
				prefill: { '*': 'Question' },
			},
		],
	},
};

const zendeskKey = zendeskTheme.checkout_v3_footer_zendeskKey || '7b1143d5-ee03-4e62-a1c6-b6204cd435ce';

export const openZendeskChat = () => {
	let retries = 0;
	const tryOpenChat = () => {
		if (window.zE && typeof window.zE.show === 'function') {
			window.zE.show();
			window.zE.activate();
		} else if (retries < 10) {
			retries++;
			setTimeout(tryOpenChat, 500);
		} else {
			console.warn('Zendesk failed to initialize after multiple attempts.');
		}
	};

	tryOpenChat();
};

const Support = () => {
	useEffect(() => {
		if (!document.querySelector('script[src*="zendesk.com"]')) {
			const script = document.createElement('script');
			script.id = 'ze-snippet';
			script.src = `https://static.zdassets.com/ekr/snippet.js?key=${zendeskKey}`;
			document.body.appendChild(script);
		}

		window.zESettings = {
			webWidget: {
				locale: window.locale,
				color: setting.color,
				launcher: setting.launcher,
				contactForm: setting.contactForm,
				chat: {
					autoOpen: false,
				},

				onReady: function () {
					if (window.zE && typeof window.zE.hide === 'function') {
						window.zE.hide();
					}
				},
			},
		};

		return () => {
			const existingScript = document.querySelector('script[src*="zendesk.com"]');
			if (existingScript) {
				existingScript.remove();
			}
		};
	}, []);

	return null;
};

export default Support;
